// extracted by mini-css-extract-plugin
module.exports = {"materials_list_item":"Prototype_materials_list_item__hCXwq","materials_list_item_btns":"Prototype_materials_list_item_btns__KUDff"};